module.exports = __webpack_public_path__ + "static/media/VISA2.685b9f11.png";